import { render, staticRenderFns } from "./payDetails.vue?vue&type=template&id=ddf9e0ea&scoped=true"
import script from "./payDetails.vue?vue&type=script&lang=js"
export * from "./payDetails.vue?vue&type=script&lang=js"
import style0 from "./payDetails.vue?vue&type=style&index=0&id=ddf9e0ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9e0ea",
  null
  
)

export default component.exports